import { createAction, props } from "@ngrx/store";
import { Families, Specification } from "../models/specification.model";

export const loadFamilies = createAction('[Specification] Load Families',);
export const loadFamiliesSuccess = createAction('[Specification] Load Families Success', props<{ families: Families[] }>());

export const loadSpecifications = createAction('[Specification] Load Specifications');
export const loadSpecificationsSuccess = createAction('[Specification] Load Specifications Success', props<{ specifications: Specification[] }>());

